/* eslint-disable */
// biome-ignore-all lint: auto-generated
// biome-ignore-all format: auto-generated
// biome-ignore-all assist: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: bun run autoexport.
//

export { default as CMYK } from "./CMYK.icc"
export { default as fogra51 } from "./fogra51.icc"
export { default as fogra52 } from "./fogra52.icc"
export { default as PSOcoated_v3_small } from "./PSOcoated_v3_small.icc"
export { default as PSOcoated_v3 } from "./PSOcoated_v3.icc"
